import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "loadingDiv",
  class: "loadingDiv",
  style: {"padding":"10px"}
}
const _hoisted_2 = { class: "loader-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_component = _resolveComponent("nav-component")!
  const _component_toasts_component = _resolveComponent("toasts-component")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_neu_content = _resolveComponent("neu-content")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_neu_app = _resolveComponent("neu-app")!
  const _component_neu_spinner = _resolveComponent("neu-spinner")!
  const _component_neu_label = _resolveComponent("neu-label")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_neu_app, {
      id: "scheduleMaintenance",
      style: _normalizeStyle(_ctx.isSpinnerLoading ? 'loading-area' : '')
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
          [_vShow, _ctx.isLoading]
        ]),
        (_ctx.showNav)
          ? (_openBlock(), _createBlock(_component_nav_component, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_toasts_component),
        _createVNode(_component_neu_content, { class: "scrollbar" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_Footer)
      ]),
      _: 1
    }, 8, ["style"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_neu_spinner, {
        class: "spinner",
        color: "primary"
      }),
      _hoisted_3,
      _createVNode(_component_neu_label, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.spinnerText), 1)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.isSpinnerLoading]
    ])
  ], 64))
}